export default defineNuxtPlugin(() => {
  if (import.meta.client) {
    const app = useAppStore();
    const cookieState = useCookieSate();
    app.initialize();
    cookieState.initialize();
  }
});
